module.exports = __webpack_public_path__ + "static/media/Chef_Egg_c2.4149d19a.png";